/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Suggest_RestInputs */

const en_us2_coach_suggest_rest = /** @type {(inputs: Coach_Suggest_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long should I rest between sets?`)
};

const pt_br2_coach_suggest_rest = /** @type {(inputs: Coach_Suggest_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto devo descansar entre as séries?`)
};

const es_419_coach_suggest_rest = /** @type {(inputs: Coach_Suggest_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto debo descansar entre series?`)
};

const pt_pt2_coach_suggest_rest = /** @type {(inputs: Coach_Suggest_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto devo descansar entre séries?`)
};

const fr_fr2_coach_suggest_rest = /** @type {(inputs: Coach_Suggest_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de repos entre les séries ?`)
};

const de_de2_coach_suggest_rest = /** @type {(inputs: Coach_Suggest_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange sollte ich zwischen den Sätzen pausieren?`)
};

const it_it2_coach_suggest_rest = /** @type {(inputs: Coach_Suggest_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto devo recuperare tra le serie?`)
};

/**
* | output |
* | --- |
* | "How long should I rest between sets?" |
*
* @param {Coach_Suggest_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_suggest_rest = /** @type {((inputs?: Coach_Suggest_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Suggest_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_suggest_rest(inputs)
	if (locale === "es-419") return es_419_coach_suggest_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_suggest_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_suggest_rest(inputs)
	if (locale === "de-DE") return de_de2_coach_suggest_rest(inputs)
	if (locale === "it-IT") return it_it2_coach_suggest_rest(inputs)
	return en_us2_coach_suggest_rest(inputs)
});
export { coach_suggest_rest as "coach.suggest_rest" }